module.exports = __webpack_public_path__ + "14e9e230a59155a81c9833d3893518ce.svg";